import produce from 'immer';

import {
  FORM_CREATE_FAILURE,
  FORM_EDIT_FAILURE,
  FORM_EDIT_SEQUENCE_FAILURE,
  FORM_EDIT_SEQUENCE_SUCCESS,
  FORM_EDIT_SUCCESS,
  FORM_FETCH_FAILURE,
  FORM_FETCH_SUCCESS,
  FORM_LIST_FETCH_FAILURE,
  FORM_LIST_FETCH_SUCCESS,
} from '@actions/form';

const initialState: IFormSectionStore = {
  currentForm: null,
  forms: null,
  error: null,
};

export default (state: IFormSectionStore = initialState, action: any) =>
  produce(state, (draftState: IFormSectionStore) => {
    switch (action.type) {
      case FORM_EDIT_SUCCESS:
      case FORM_FETCH_SUCCESS:
        draftState.currentForm = action.response;
        draftState.error = null;

        return;

      case FORM_EDIT_FAILURE:
      case FORM_CREATE_FAILURE:
      case FORM_FETCH_FAILURE:
        draftState.currentForm = null;
        draftState.error = action.error;

        return;

      case FORM_LIST_FETCH_FAILURE:
      case FORM_EDIT_SEQUENCE_FAILURE:
        draftState.forms = null;
        draftState.error = action.error;

        return;

      case FORM_LIST_FETCH_SUCCESS:
      case FORM_EDIT_SEQUENCE_SUCCESS:
        draftState.forms = action.response;
        draftState.error = null;

        return;
    }
  });
